import { yupResolver } from '@hookform/resolvers/yup';
import { GuestJourneySettings } from 'api/reports-service/guest-journey-reports.types';
import { Resolver, useForm } from 'react-hook-form';
import { guestJourneySettingsSchema } from './guest-journey-settings.schema';

/**
 * React Hook Form instance for the Guest Journey Settings editor, seeded once
 * from the loaded settings and validated against `guestJourneySettingsSchema`
 * (so nothing invalid is ever submitted to the BE).
 */
export const useGuestJourneySettingsForm = (initial: GuestJourneySettings) =>
  useForm<GuestJourneySettings>({
    // The schema is inferred (yup's typing doesn't line up with an explicit
    // ObjectSchema<GuestJourneySettings>), so cast the resolver to the form type.
    resolver: yupResolver(
      guestJourneySettingsSchema,
    ) as Resolver<GuestJourneySettings>,
    defaultValues: initial,
    mode: 'onChange',
  });
